module.exports = __webpack_public_path__ + "static/media/ico_notifications.c3978ebd.svg";